export default __webpack_public_path__ + "static/media/AR luik rechtsdraaiend.jpg";